import { Button } from "@mui/material";
import { muiTheme } from "@/styles/theme";

interface ResetOrganisationButtonProps {
  onReset?: () => void;
}

const ResetOrganisationButton: React.FC<ResetOrganisationButtonProps> = ({
  onReset,
}) => {
  return (
    <Button
      variant="contained"
      onClick={onReset}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        borderRadius: 2,
        maxWidth: "110px`",
        maxHeight: "40px",
        minWidth: "110px",
        border: `1px solid ${muiTheme.colorSchemes.light.palette.warning[600]}`,
        color: muiTheme.colorSchemes.light.palette.warning[600],
        background: muiTheme.colorSchemes.light.palette.main.white,
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        ...muiTheme.typography.action_button,
        textTransform: "none",
        "&:hover": {
          color: muiTheme.colorSchemes.light.palette.warning[600],
          background: "#fff6ea",
          boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        },
        "&:active": {
          boxShadow:
            "0px 0px 0px 4px #F2F4F7, 0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        },
      }}
    >
      Reset
    </Button>
  );
};

export default ResetOrganisationButton;
